import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {TeamModel} from "../../../schemas/team.model";
import {AssigmentService} from "../../../services/assigment.service";
import {ResponsibleModel} from "../../../schemas/responsible.model";
import {CustomerModel} from "../../../schemas/customer.model";
import {MessageService} from "primeng/api";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-search-dialog',
    templateUrl: './search-dialog.component.html',
    styleUrls: ['./search-dialog.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class SearchDialogComponent implements OnInit {

    searchForm: FormGroup = new FormGroup({});
    process!: string;
    teamsModel: TeamModel[] = [];
    selectedTeamId: string = '';
    customerModel: CustomerModel[] = [];
    responsibleModel: ResponsibleModel[] = [];

    constructor(private fb: FormBuilder,
                public config: DynamicDialogConfig,
                private messageService: MessageService,
                private assigmentService: AssigmentService,
                public ref: DynamicDialogRef,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            searchQuery: [''],
        });
        if (this.config.header?.includes(this.translateService.instant('search.team'))) {
            this.process = 'TEAM';
        }
        if (this.config.header?.includes(this.translateService.instant('search.customer'))) {
            this.process = 'CUSTOMER';
        }
        if (this.config.header?.includes(this.translateService.instant('search.responsible'))) {
            this.selectedTeamId = this.config.data;
            this.process = 'RESP';
        }
    }

    selectItem(team: TeamModel) {
        console.log(team);
        this.ref.close(team);
    }

    selectResp(resp: ResponsibleModel) {
        console.log(resp);
        this.ref.close(resp);
    }

    selectCustomer(resp: CustomerModel) {
        console.log(resp);
        this.ref.close(resp);
    }

    searchName() {
        const searchQuery = this.searchForm.get('searchQuery')?.value ?? '';

        if (this.process == 'CUSTOMER') {
            this.assigmentService.getCustomer(searchQuery).subscribe({
                next: (response) => {
                    this.customerModel = response;
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Service Message',
                        detail: this.translateService.instant('search.error.customers')
                    });
                    console.error(err)
                }
            })
        }
        if (this.process == 'RESP') {
            const areaParam = this.selectedTeamId === null ? '' : this.selectedTeamId;
            this.assigmentService.getResponsible(searchQuery, areaParam).subscribe({
                next: (response) => {
                    this.responsibleModel = response;
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Service Message',
                        detail: this.translateService.instant('search.error.managers')
                    });
                    console.error(err)
                }
            })
        }
        if (this.process == 'TEAM') {
            this.assigmentService.getTeams(searchQuery).subscribe({
                next: (response) => {
                    this.teamsModel = response;
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Service Message',
                        detail: this.translateService.instant('search.error.teams')
                    });
                    console.error(err)
                }
            })
        }
    }
}
